import { useContext } from 'react';
import { RefreshContext, type RefreshContextValue } from '@/contexts/RefreshContext';

export function useRefresh(): RefreshContextValue {
  const ctx = useContext(RefreshContext);
  if (!ctx) throw new Error('useRefresh must be used inside <RefreshProvider>');
  return ctx;
}
